<template>
<section>
  <section class="section is-title-bar">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <p class="title is-5">Pincode Serviceability Check</p>
        </div>
      </div>
    </div>
  </section>
  <section class="section is-main-section">
    <div class="column is-8">
      <div class="box">
        <form class="container" name="checkPincodeServiceabality" @submit.prevent="checkPincodeServiceabality">
          <div class="column">
            <label class="label">Where do you want us to deliver your Kit?</label>
          </div>
          <div class="columns">
            <div class="column is-8">
              <input class="input" type="number" min='100000' max='999999' replaceholder="Enter Pincode" v-model.trim="pincode" length="6" maxlength="6" minlength="6" />
            </div>
            <div class="column is-4">
              <button class="button is-primary" type="submit">
                Check
              </button>
            </div>
          </div>
          <div class="column" v-if="isError">
            <label class="label" style="color:red">We are currently not available at this location..Stay tuned!</label>
          </div>
             <div class="column" v-if="isSuccess">
            <label class="label" style="color:green">We are currently available at this location..Stay tuned!</label>
          </div>
        </form>
      </div>
    </div>
    </div>
  </section>
</section>
</template>
<script>
import constants from '@/utils/constants'
export default {
  name: 'ViewFranshisee',
  props: ['franchiseeId'],
  data () {
    return {
      pincode: null,
      isError: false,
      isSuccess: false,
      responseData: {}
    }
  },
  created () {},
  methods: {
    checkPincodeServiceabality: async function (pincode) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(`${constants.API_URL}/api/pincode-check/${this.pincode}`)
        this.responseData = response.data

        this.loadingComponent.close()
        this.isError = false
        this.isSuccess = true
        // return this.$buefy.dialog.alert({
        //   type: 'is-danger',
        //   message: this.responseData.message,
        //   hasIcon: true,
        //   animation: 'zoom-out',
        //   size: 'is-medium',

        //   icon: ' mdi-exclamation',
        //   iconPack: 'mdi',
        //   ariaRole: 'alertdialog',
        //   ariaModal: true
        // })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.enableUniformModal = false
        this.loadingComponent.close()
        console.log('error in fetching franchisee : ', errorMessage)
        this.isError = true
        this.isSuccess = false
        // return this.$buefy.dialog.alert({
        //   type: 'is-danger',
        //   message: errorMessage,
        //   hasIcon: true,
        //   animation: 'zoom-out',
        //   size: 'is-medium',

        //   icon: ' mdi-exclamation',
        //   iconPack: 'mdi',
        //   ariaRole: 'alertdialog',
        //   ariaModal: true
        // })
      }

      // if (this.pincode === '123456') {
      //   this.isError = true
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
